import React from 'react'
import cx from 'classnames'
import styles from './Dimmer.module.scss'

interface IDimmerProps {
  active?: boolean
  fadeStyle?: 'flat' | 'gradient'
  bgColor?: 'appBg' | 'white' | 'dark' | 'transparent'
  disabled?: boolean
  children?: React.ReactNode | null
}

const Dimmer = ({ active = false, fadeStyle = 'flat', bgColor = 'appBg', disabled, children }: IDimmerProps) => {
  const classNames = cx(styles.root, {
    [styles.active]: active,
    [styles.gradient]: fadeStyle === 'gradient',
    [styles['bg-white']]: bgColor === 'white',
    [styles['bg-dark']]: bgColor === 'dark',
    [styles.disabled]: disabled,
  })

  return <div className={classNames}>{children}</div>
}

export default Dimmer
